import { CONFIG, authFetch, authHeaders } from '../utils/config';

export class CartService {

  static async addToCart(uuid) {
    try {
      const response = await authFetch(`${CONFIG.BASE_URL}/add-to-cart/${uuid}`, {
        method: 'PATCH',
        headers: authHeaders(),
      });

      const data = await response.json();

      if (response.ok) {
        return { success: true, message: data.message };
      }

      if (response.status === 400 && data.error === 'Item already taken') {
        return { success: false, message: 'Ce QR code a déjà été pris par un autre utilisateur' };
      }

      return { success: false, message: data.error || 'Erreur lors de l\'ajout au panier' };
    } catch (error) {
      console.error('Erreur lors de l\'ajout au panier:', error);
      return { success: false, message: 'Erreur de connexion au serveur' };
    }
  }


  static async removeFromCart(uuid) {
    try {
      const response = await authFetch(`${CONFIG.BASE_URL}/remove-from-cart/${uuid}`, {
        method: 'PATCH',
        headers: authHeaders(),
      });

      const data = await response.json();

      if (response.ok) {
        return { success: true, message: data.message };
      }

      return { success: false, message: data.error || 'Erreur lors du retrait du panier' };
    } catch (error) {
      console.error('Erreur lors du retrait du panier:', error);
      return { success: false, message: 'Erreur de connexion au serveur' };
    }
  }


  static async getCartContent() {
    try {
      const response = await authFetch(`${CONFIG.BASE_URL}/shopping-cart-content?miniature=true`, {
        method: 'GET',
        headers: authHeaders(),
      });

      if (response.ok) {
        const items = await response.json();
        return { success: true, items: Array.isArray(items) ? items : [] };
      }

      const data = await response.json();
      
      if (response.status === 404) {
        return { success: true, items: [] };
      }

      return { success: false, items: [], message: data.error || 'Erreur lors de la récupération du panier' };
    } catch (error) {
      console.error('Erreur lors de la récupération du panier:', error);
      return { success: false, items: [], message: 'Erreur de connexion au serveur' };
    }
  }


  static async getPaymentPageUrl() {
    try {
      const response = await authFetch(`${CONFIG.BASE_URL}/pay-shopping-cart-page`, {
        method: 'GET',
        headers: authHeaders(),
      });

      const data = await response.json();

      if (response.ok && data.url) {
        return { success: true, url: data.url };
      }

      if (response.status === 404) {
        if (data.error === 'No shopping cart') {
          return { success: false, message: 'Votre panier est vide' };
        }
        return { success: false, message: 'Utilisateur non trouvé' };
      }

      return { success: false, message: data.error || 'Erreur lors de la récupération du lien de paiement' };
    } catch (error) {
      console.error('Erreur lors de la récupération du lien de paiement:', error);
      return { success: false, message: 'Erreur de connexion au serveur' };
    }
  }


  static calculateTotal(items) {
    return items.reduce((total, item) => total + (item.price || 9.99), 0);
  }
}

export default CartService;
